package cc.easyandroid.easycompose.component.router.children

import cc.easyandroid.easycompose.core.instancekeeper.InstanceKeeperDispatcher
import cc.easyandroid.easycompose.core.statekeeper.SerializableContainer

internal interface ChildItemFactory<C : Any, out T : Any> {

    operator fun invoke(
        configuration: C,
        key: String,
        savedState: SerializableContainer? = null,
        instanceKeeperDispatcher: InstanceKeeperDispatcher? = null,
    ): ChildItem.Created<C, T>
}
